import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
    FunctionComponent,
} from "react";
import { connect, useDispatch } from "react-redux";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton } from '@mui/material';

type props = {
    title: string,
    description: string,
    Id:string,
    open: any,
    setOpen: any,
    reload?:boolean
};

const IntegrationVerification: FunctionComponent<props> = ({
    title,
    description,
    Id,
    open,
    setOpen,
    reload
}) => {

    const handleClose = () => {
        setOpen(false);
        if(reload===true){window.location.reload()}
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(Id).then(() => {
            handleClose()
        }).catch((err) => {
            console.error('Could not copy text: ', err);
        });
    };
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {description}
                    </DialogContentText>
                </DialogContent>
                <DialogContent >
                <Box display="flex" alignItems="center">
                    <DialogContentText color={"blue"} id="alert-dialog-description">
                        {Id}
                    </DialogContentText>
                    <IconButton aria-label="Copy URL" onClick={handleCopy}>
                  <ContentCopyIcon />
                </IconButton>
                </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

const mapStateToProps = (state: any) => {
    return {
    };
};

export default connect(mapStateToProps)(IntegrationVerification);